import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { patchCurrentUser } from 'src/state/users'
import { UserPatchType } from '@meniudigital/shared'
import Button from 'src/global/Button'
import { useNavigate } from 'react-router-dom'
import { Screen } from 'src/screens'
import SchedulePills from 'src/screens/SetScheduleScreen/SchedulePills'
import Setting from '../Setting'

export default function ScheduleSetting() {
  const dispatch = useDispatch()
  const { user } = useSelector((state: State) => state.users)
  const navigate = useNavigate()

  if (!user) {
    return null
  }

  const { schedule } = user

  const goToSchedulePicker = () => {
    window.hideSettingsModal()
    navigate(Screen.SetSchedule)
  }

  const toggleSchedule = () => {
    dispatch(
      patchCurrentUser({
        type: UserPatchType.Schedule,
        data: { ...(schedule || {}), isVisible: !schedule?.isVisible },
      } as any),
    )
  }

  return (
    <Setting
      title="Programul de Lucru"
      iconPath="/icons/calendar.png"
      isEnabled={schedule?.isVisible}
      onToggle={toggleSchedule}
      body={
        <>
          <div className="gray-box">{Boolean(schedule?.schedule?.length) && <SchedulePills schedule={schedule!.schedule} />}</div>
          <Button
            variant="as-text"
            text={`${schedule?.schedule.length ? 'Schimbă' : 'Setează'} programul de lucru...`}
            onClick={goToSchedulePicker}
          />
        </>
      }
    />
  )
}
